import dynamic from 'next/dynamic';
import React from 'react';

import { Client } from '@/types/app';

const InnerMobileWebLayout = dynamic(() => import('@/components/layouts/InnerMobileWebLayout'), { ssr: true });
const InnerWebLayout = dynamic(() => import('@/components/layouts/InnerWebLayout'), { ssr: true });
const InnerWebViewLayout = dynamic(() => import('@/components/layouts/InnerWebViewLayout'), { ssr: true });

interface Props {
  children: React.ReactNode;
  userAgent: string;
  client: Client;
}

const DefaultLayout = ({ children, client, userAgent }: Props) => {
  if (client.isWebView) {
    return <InnerWebViewLayout>{children}</InnerWebViewLayout>;
  }

  if (client.isMobile) {
    return (
      <InnerMobileWebLayout client={client} userAgent={userAgent}>
        {children}
      </InnerMobileWebLayout>
    );
  }

  return (
    <InnerWebLayout client={client} userAgent={userAgent}>
      {children}
    </InnerWebLayout>
  );
};

export default DefaultLayout;
